<template>
  <div>
    <vs-button v-if="usedTempsave" ref="refMobileSaveBtn" class="absolute right-0 shadow-lg btn-back-to-top px-0" style="width: 80px; bottom: 60px" @click.stop="onClickTempsave">임시저장</vs-button>

    <div class="xl:flex items-stretch gap-5">
      <vx-card class="flex-1 mb-6 xl:mb-0 xl:w-0">
        <div class="flex flex-wrap gap-4 mb-6">
          <div class="mr-auto" style="display: grid; align-items: center">
            <slot name="header" :board="board" :isPrint="isPrint" />
          </div>
          <div id="right-button-container" class="ml-auto flex flex-wrap justify-end gap-4">
            <slot
              name="approval-right"
              :mode="isUpdateMode ? 'u' : 'c'"
              :func="{
                close: onClickClose, // 닫기
                move: onClickMoveList, // 목록으로 이동
                copysave: onClickCopySave, // 복사후저장
                save: onClickTempsave, // 임시저장
                print: onClickPrint, // 인쇄
                delete: onClickDelete, // 삭제
                recall: onClickRecall, // 회수
                resend: onClickReTempsave, // 재상신
                revision: onClickRevision, // 개정
              }"
            >
              <vs-button v-if="usedRevision" color="secondary" type="border" @click="onClickRevision()">개정</vs-button>
              <vs-button v-if="!isUpdateMode && usePrevPost" color="secondary" type="border" @click="$emit('prevPost')" class="hidden xl:block">{{ prevPostButtonLabel }}</vs-button>
              <vs-button v-if="isUpdateMode && usePrint" color="secondary" @click="onClickPrint">{{ printLabel }}</vs-button>
              <vs-button v-if="isDeleteAvailable" color="secondary" type="border" @click="onClickDelete">삭제</vs-button>
              <vs-button color="secondary" type="border" @click="onClickMoveList('list')">목록</vs-button>
              <vs-button v-if="usedRecalled && permission && permission.d" color="secondary" @click="onClickRecall">결재문서 회수</vs-button>
              <vs-button v-if="usedTempsave" color="secondary" @click="onClickTempsave">임시저장</vs-button>
              <vs-button v-if="board.resend && permission && permission.u" color="secondary" @click="onClickReTempsave('')"> 재상신 </vs-button>
            </slot>
          </div>
        </div>

        <div id="print-report" class="overflow-x-hidden">
          <slot name="body" :board="board" :isPrint="isPrint" />
        </div>
      </vx-card>

      <vs-col style="flex: 0" class="flex">
        <div class="hidden xl:block z-10">
          <label class="toggle-btn" @click="onClickToggleSide">
            <feather-icon v-if="this.toggleSide" icon="ChevronRightIcon" style="width: 18px; height: 18px" />
            <feather-icon v-else icon="ChevronLeftIcon" style="width: 18px; height: 18px" />
          </label>
        </div>
        <approval-process-module
          :board="board"
          :isPrint="isPrint"
          :show-approval-time="true"
          :commentabled="!(board.isCompleteApproval || board.savable)"
          @handleClickUpload="_onClickApprovalUpload"
          @handleClickOk="_onClickApprovalOk"
          @handleClickNo="_onClickApprovalNo"
          @handleSendApprovalProcess="_onChangeApproval"
          style="min-width: 360px; flex: 1"
          :style="{ display: this.toggleSide ? 'block' : 'none' }"
        ></approval-process-module>
      </vs-col>
    </div>

    <!-- TODO : 얼럿데이터 -->
    <popup-alert v-model="alert.show" :is-confirm="alert.isConfirm" :html="alert.html" :message="alert.message" :buttons="alert.buttons" @ok="onClickOk" @no="onClickNo" @upload="onClickUpload" @print="onClickPrint"></popup-alert>
  </div>
</template>

<script>
import ApprovalProcessModule from "@/views/modules/ApprovalProcessModule";
import PopupAlert from "@/popup/PopupAlert";

export default {
  name: "ApprovalDocument2",
  components: {
    PopupAlert,
    ApprovalProcessModule,
  },
  props: {
    docProjectId: String | Number,
    docInfo: Object,
    form: Object,
    usePrint: {
      type: Boolean,
      default: true,
    },
    printLabel: {
      type: String,
      default: () => "인쇄",
    },
    tab: Object,
    permission: Object | undefined,
    useFinishLater: {
      type: Boolean,
      default: false,
    },
    isFinishLater: {
      type: Boolean,
      default: false,
    },
    usePrevPost: {
      type: Boolean,
      default: false,
    },
    // 개정 기능 사용여부
    useRevision: {
      type: Boolean,
      default: false,
    },
    prevPostButtonLabel: {
      type: String,
      default: () => "이전 문서 불러오기",
    },
  },
  computed: {
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    isNewDocument() {
      return !this.postId || isNaN(this.postId);
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
    // 게시판별 결재 옵션 (tab-items.js approvalOptions)
    approvalOptions() {
      return (this.tab && this.tab.approvalOptions) || {};
    },
    // approvalOptions.referenceUserWhen 이 있으면 그 조건을 만족할 때만 대상자를 수신참조에 넣는다 (예: 1229 는 구분1 이 직영일 때만)
    isReferenceUserAllowed() {
      const when = this.approvalOptions.referenceUserWhen;
      if (typeof when !== "function") return true;
      try {
        return !!when(this.form || {});
      } catch (e) {
        return false;
      }
    },
    // approvalOptions.referenceUserPath 가 가리키는 문서 본문의 회원 id (예: "대상자.id" → form.대상자.id)
    // 조건(referenceUserWhen)에 맞지 않으면 0 을 돌려주고, syncReferenceUser 가 자동 추가했던 참조를 뺀다
    referenceUserId() {
      const path = this.approvalOptions.referenceUserPath;
      if (!path || !this.form) return 0;
      if (!this.isReferenceUserAllowed) return 0;
      let value = this.form;
      for (const key of `${path}`.split(".")) {
        value = value ? value[key] : undefined;
      }
      return parseInt(value) || 0;
    },
    // 결재선을 고칠 수 있는 상태인가 (신규작성 / 작성자의 임시저장 문서 / 내 결재 차례)
    canEditApprovalLine() {
      return this.isNewDocument || (this.board.statusCode === "temp" && this.board.isWriter) || !!this.board.isTurnApproval;
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    usedDelete() {
      // 결재완료/진행중/반려 상태에서는 작성자도 삭제할 수 없다 (getLevel === 1 인 경우는 예외)
      const isRestrictedStatus = ["approved", "ongoing", "rejected"].indexOf(this.board.statusCode) > -1 && this.getLevel !== 1;
      return this.isUpdateMode && this.board.isWriter && !isRestrictedStatus;
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        const projectId = this.$route.params.proj_id;
        for (const proj of projects) {
          if (proj.id == projectId && proj.company.length > 0) {
            const path = proj.company[0].pivot.company_path;
            return path.split("/").length - 1;
          }
        }
      }
    },
    usedRecalled() {
      return this.isUpdateMode && this.board.isWriter && this.board.statusCode === "registered";
    },
    usedTempsave() {
      return !this.isUpdateMode || (this.board.isWriter && this.board.statusCode === "temp");
    },
    usedRevision() {
      if (this.useRevision && this.isUpdateMode) {
        if (this.docInfo && this.docInfo.status) {
          return this.docInfo.status.code === "approved";
        }
        return true;
      }
      return false;
    },
    isUpdateMode() {
      return this.$route.params.postId > 0;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    finishLater: {
      get() {
        return this.isFinishLater;
      },
      set(value) {
        this.$emit("update:isFinishLater", value);
      },
    },
    postData() {
      if (this.$store.state.approval.postInfo.post_content) return JSON.parse(this.$store.state.approval.postInfo.post_content).body;
      else return {};
    },
    isDeleteAvailable() {
      // 작성 기능이 꺼져있으면 수정 불가
      if (!this.isUpdateMode) return false;

      // 시스템 관리자면 수정 가능
      if (this.isAdmin) return true;
      return this.usedDelete && this.permission && this.permission.d;
    },
  },
  watch: {
    projectInfo(value) {
      if (value) {
        this.board.projectTitle = value.field_name;
      }
    },
    docInfo(doc) {
      const board = JSON.parse(JSON.stringify(this.board));
      const myId = this.myInfo.id;
      board.slug = doc.slug;
      board.statusCode = doc.status.code;
      board.writer = doc.writer;
      board.turnApprovalId = doc.turn_approval_id;
      board.isWriter = board && board.writer && (board.writer.id === myId);

      // 처리부서를 처리한다
      if (doc && doc.approval_document_companies && Array.isArray(doc.approval_document_companies) && doc.approval_document_companies.length > 0) {
        for (const company of doc.approval_document_companies) {
          if (!company || !company.virtual_company) continue;

          if (company.element_type === "결재") {
            if (!board.documentCompany) {
              board.documentCompany = {
                document_company_id: company.id || null,
                virtual_company_id: company.virtual_company.id || null,
                id: Array.isArray(company.virtual_company.full_code) ? company.virtual_company.full_code.join("\\") : "",
                code: company.virtual_company.code || "",
                label: company.virtual_company.com_name || "",
                full_label: company.virtual_company.full_name || "",
              };
            }
          } else if (company.element_type === "참조") {
            if (!board.referenceCompanies) {
              board.referenceCompanies = [];
            }

            if (board.referenceCompanies.find(item => item.document_company_id === company.id)) {
              continue;
            }
            board.referenceCompanies.push({
              document_company_id: company.id || null,
              virtual_company_id: company.virtual_company.id || null,
              id: Array.isArray(company.virtual_company.full_code) ? company.virtual_company.full_code.join("\\") : "",
              code: company.virtual_company.code || "",
              label: company.virtual_company.com_name || "",
              full_label: company.virtual_company.full_name || "",
            });
          }
        }
      }

      // 현재 결재 문서를 "승인"할 차례인지 여부
      board.isTurnApproval = false; // 기본값 설정

      if (board && myId) {
        board.isTurnApproval = board.turnApprovalId === myId && (board.statusCode === "registered" || board.statusCode === "ongoing");

        // 처리부서 여부에 따라서 턴이 될 수도 있다.
        if (!board.isTurnApproval && doc && Array.isArray(doc.line)) {
          // 만약 아직 승인하지 않은 사용자가 있다면, 내 턴이 아니다
          let hasWaitApproval = false;

          for (const line of doc.line) {
            if (line && ["register", "approval"].includes(line.type_code) && line.status_code === "wait") {
              hasWaitApproval = true;
              break;
            }
          }

          // 결재선 중에, 처리부서의 업체가 할당된 사용자가 있는지 확인
          let hasCompanyApproval = false;
          let documentCompanyId = 0;
          if (board && board.documentCompany && board.documentCompany.document_company_id) {
            documentCompanyId = board.documentCompany.document_company_id;
          }
          for (const line of doc.line) {
            if (line.document_company_id === documentCompanyId) {
              hasCompanyApproval = true;
              break;
            }
          }

          // 처리부서에 할당된 사용자가 없고, 내가 처리부서에 소속된 인원이라면 턴이다.
          if (!hasCompanyApproval) {
            // 만약 모든 사용자가 승인한 시점이라면, 나의 virtual_company_id 값이 documentCompany.virtual_company_id 값과 같다면 턴이다.
            if (!hasWaitApproval && this.myInfo && board.documentCompany) {
              // 현재 사용자의 virtual_company_id 값
              const myVirtualCompanyId = this.myInfo.virtual_company_id;
              // 문서의 처리부서의 virtual_company_id 값
              const docVirtualCompanyId = board.documentCompany.virtual_company_id;

              // 두 값이 모두 존재할 때만 비교
              if (myVirtualCompanyId !== undefined && docVirtualCompanyId !== undefined) {
                board.isTurnApproval = myVirtualCompanyId === docVirtualCompanyId;
              }
            }
          }
        }
      }

      board.readonly = !((board.statusCode === "temp" && board.isWriter === true) || board.isTurnApproval);
      if (!board.readonly) {
        // 다른 프로젝트에서 불러왔을 경우에는 읽기전용으로
        if (this.tab.byCurrentLocation && this.projectId !== this.docProjectId) {
          board.readonly = true;
        }
      }

      // 작성권한이 없을 경우 읽기전용으로 변경
      if (!this.permission.c) {
        board.readonly = true;
      }

      board.resend = board.isWriter && board.statusCode === "rejected";
      board.isCompleteApproval = board.statusCode === "approved" || board.statusCode === "rejected";

      board.savable = board.statusCode === "temp";
      board.collection = board.isWriter && board.statusCode === "registered";

      // 모듈 표기용
      board.approvalLine = doc.line.slice();

      board.approvalOptions = this.approvalOptions;
      // 임시저장 문서를 다시 열었을 때도 수신참조 기본 부서를 채워준다
      if (board.statusCode === "temp") this.applyDefaultReferenceCompany(board);

      this.board = board;
      // 문서 상태가 확정된 뒤 대상자 참조를 다시 맞춘다 (본문이 먼저 로드되어 동기화가 건너뛰어졌을 수 있음)
      this.syncReferenceUser();
    },
    // 대상자가 선택/변경/삭제되면 수신참조도 같이 바꾼다
    referenceUserId: {
      immediate: true,
      handler() {
        this.syncReferenceUser();
      },
    },

    board: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("board", value, JSON.stringify(this.lineToSendLine(this.board.approvalLine)));
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        // TODO : 데이터가 바뀌었을때만 저장버튼 나오도록 수정
        // if (Object.keys(value).length === Object.keys(this.postData).length && JSON.stringify(value) !== JSON.stringify(this.postData)) console.log("form", value);
        this.board.stdInfo = value.stdInfo || {};
      },
    },
  },
  data() {
    return {
      // TODO : 글쓰기 정보 및 권한
      board: {
        slug: "",
        projectTitle: this.$store.state.project.projectInfo.field_name,
        statusCode: "", // 문서 상태코드
        writer: {}, //작성자 정보
        turnApprovalId: 0, // 결재자 ID
        isWriter: true, // 작성자인가
        readonly: false, // 읽기전용인가
        savable: true, // 임시저장이 가능하나
        isCompleteApproval: false, // 결재완료된 문서인가
        isTurnApproval: false, // 결재할 차례인가
        approvalLine: [], // 결재라인
        commentList: [], // 댓글리스트
        stdInfo: {},  // 결재문서에 포함된 기본정보
        referenceCompanies: [], // 참조부서
        approvalOptions: {}, // 게시판별 결재 옵션 (처리부서 사용 여부 등) - ApprovalProcessModule/PopupApprovalProcess 에서 참조
      },
      // approvalOptions.defaultReferenceCompany 로 조회한 수신참조 기본 부서 정보
      defaultReferenceCompany: null,
      // 대상자로 수신참조에 자동 추가한 회원 id (대상자 변경 시 이전 항목을 찾아 제거하는 데 사용)
      autoReferenceUserId: 0,

      // TODO : 얼럿데이터
      alert: {
        show: false,
        message: "결재하시겠습니까?",
        buttons: [
          { label: "승인", action: "ok" },
          { label: "취소", action: "cancel" },
        ],
      },

      toggleSide: true,
      isPrint: false,

      screenSize: window.innerWidth, // 초기 화면 크기
      previousBreakpoint: this.getBreakpoint(window.innerWidth), // 이전 브레이크포인트 상태
    };
  },

  mounted() {
    window.addEventListener("resize", this.handleResize); // resize 이벤트 등록

    this.board.approvalOptions = this.approvalOptions;
    this.loadDefaultReferenceCompany();

    // 신규 문서 작성일 경우, 작성자 정보를 업데이트한다
    if (this.isNewDocument) {
      this.initUserInfo();
    }

    if (this.$refs.refMobileSaveBtn) {
      const refMobileSaveBtn = this.$refs.refMobileSaveBtn instanceof HTMLElement ? this.$refs.refMobileSaveBtn : this.$refs.refMobileSaveBtn.$el;

      if (refMobileSaveBtn) {
        // #scroll-up-btn 아래로 이동
        const scrollUpBtn = document.getElementById("scroll-up-btn");
        if (scrollUpBtn) {
          scrollUpBtn.insertAdjacentElement("afterend", refMobileSaveBtn);
        }
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize); // resize 이벤트 해제

    if (this.$refs.refMobileSaveBtn) {
      const refMobileSaveBtn = this.$refs.refMobileSaveBtn instanceof HTMLElement ? this.$refs.refMobileSaveBtn : this.$refs.refMobileSaveBtn.$el;

      if (refMobileSaveBtn && refMobileSaveBtn.parentNode) {
        refMobileSaveBtn.parentNode.removeChild(refMobileSaveBtn);
      }
    }
  },
  methods: {
    getBreakpoint(width) {
      // 현재 화면 크기를 기준으로 브레이크포인트 반환 (tailwind xl)
      if (width >= 1200) return "pc";
      else return "mobile";
    },
    handleResize() {
      const newBreakpoint = this.getBreakpoint(window.innerWidth);

      if (newBreakpoint !== this.previousBreakpoint) {
        // 브레이크포인트가 변경된 경우에만 상태 업데이트
        this.toggleSide = true;

        this.previousBreakpoint = newBreakpoint; // 이전 브레이크포인트 업데이트
      }
    },

    initUserInfo() {
      /**
       * 가상업체 정보가 존재하는 경우 (동국제강 내부)
       * 상위 부서 정보를 department 에 담는다
       */
      let section = this.$store.state.auth.userInfo.section;
      const virtualCompany = this.$store.state.member && this.$store.state.member.memberInfo && this.$store.state.member.memberInfo.virtual_company ? this.$store.state.member.memberInfo.virtual_company : undefined;
      if (virtualCompany) {
        const fullName = virtualCompany.full_name;
        if (Array.isArray(fullName) && fullName.length > 0) {
          const index = Math.max(0, fullName.length - 2);
          section = fullName[index];
        }
      }

      this.board.writer = {
        id: this.$store.state.auth.userInfo.id,
        name: this.$store.state.auth.userInfo.name,
        company_id: this.$store.state.auth.userInfo.company_id,
        department: this.$store.state.auth.userInfo.department,
        section,
        rank: this.$store.state.auth.userInfo.rank,

        // 가상 업체 정보 추가
        virtual_company: (this.$store.state.member && this.$store.state.member.memberInfo && this.$store.state.member.memberInfo.virtual_company) ? this.$store.state.member.memberInfo.virtual_company : undefined,
      };
    },
    // TODO : 결재프로세스
    // ApprovalProcessModule 에서 사용하는 line 방식에서 전송용 line 으로 변경
    // register: 상신
    // consultation : 합의
    // approval : 결재
    // reference : 참조
    // perform : 시행
    // circulation : 회람

    lineToSendLine(data, includeRegister) {
      const approvalList = [];

      for (const member of data) {
        if (!member) continue;
        if (member.type_code !== "register" || includeRegister) {
          if (!member.user_id) continue;
          approvalList.push({
            id: member.user_id,
            name: member.user_name,
            elementType: member.type_code,
            stepLine: member.stepLine,
            companyId: member.company_id,
          });
        }
      }
      return approvalList;
    },

    //
    // ===== ui event =====
    //
    onClickToggleSide() {
      this.toggleSide = !this.toggleSide;
    },
    onClickUpload() {
      const line = this.lineToSendLine(this.board.approvalLine);
      // 게시판 옵션에 따라 문서의 대상자·기본 부서를 수신참조에 자동 추가한다
      this.appendDefaultReferenceUser(line);
      this.applyDefaultReferenceCompany(this.board);
      this.$emit("upload", JSON.stringify(line), JSON.stringify(this.board.documentCompany), JSON.stringify(this.board.referenceCompanies));
    },

    /**
     * approvalOptions.defaultReferenceCompany 에 지정된 가상부서를 찾아 둔다.
     * 1) fieldId 가 있으면 서버 사이트 설정 "기본처리부서"에서 그 사업장 항목의 가상부서를 쓴다 (ApprovalProcessModule 과 같은 1시간 로컬 캐시)
     * 2) 없으면 name 으로 가상부서를 조회한다
     * 신규/임시저장 문서면 바로 수신참조 부서에 넣는다.
     */
    async loadDefaultReferenceCompany() {
      const option = this.approvalOptions.defaultReferenceCompany;
      if (!option) return;
      try {
        let found = null;
        if (option.fieldId) {
          const item = (await this.loadDefaultDocumentCompanyConfig()).find((row) => Number(row.field_id) === Number(option.fieldId));
          if (item && item.virtual_company && item.virtual_company.code) found = item.virtual_company;
        }
        if (!found && option.name) {
          const response = await this.$store.dispatch("company/LOAD_VIRTUAL_COMPANY_LIST", {
            page: 1,
            perPage: 50,
            keyword: option.name,
            projectId: this.projectId,
          });
          const list = (response && response.data) || [];
          found = list.find((company) => company.com_name === option.name) || null;
        }
        if (!found) return;
        this.defaultReferenceCompany = {
          // 기본처리부서 설정에는 full_code 가 없을 수 있어 그때는 code 를 id 로 쓴다 (팝업 목록 키 용도)
          id: Array.isArray(found.full_code) ? found.full_code.join("\\") : found.code,
          virtual_company_id: found.id,
          code: found.code,
          label: found.com_name,
          full_label: found.full_name,
        };
        if (this.isNewDocument || this.board.statusCode === "temp") {
          this.applyDefaultReferenceCompany(this.board);
        }
      } catch (e) {
        /* 조회 실패 시 자동 추가만 생략 */
      }
    },
    /**
     * 서버 사이트 설정 "기본처리부서" 목록을 읽는다. ApprovalProcessModule 과 같은 로컬 캐시 키를 써서 1시간 안에는 다시 호출하지 않는다.
     * @returns {Array<{field_id:number, virtual_company:{id:number, code:string, com_name:string, full_code:string[], full_name:string[]}}>}
     */
    async loadDefaultDocumentCompanyConfig() {
      const cacheKey = `${window.location.hostname}_기본처리부서.3`;
      try {
        const cached = JSON.parse(localStorage.getItem(cacheKey) || "null");
        if (cached && Array.isArray(cached.data) && new Date().getTime() - cached.timestamp < 3600 * 1000) {
          return cached.data;
        }
      } catch (e) {
        /* 캐시가 깨져 있으면 새로 읽는다 */
      }
      const config = await this.$store.dispatch("keyValue/LOAD_CONFIG", { key: "기본처리부서" });
      if (!Array.isArray(config)) return [];
      try {
        localStorage.setItem(cacheKey, JSON.stringify({ data: config, timestamp: new Date().getTime() }));
      } catch (e) {
        /* 저장 실패는 무시 */
      }
      return config;
    },
    applyDefaultReferenceCompany(board) {
      const company = this.defaultReferenceCompany;
      if (!company || !board) return;
      if (!Array.isArray(board.referenceCompanies)) board.referenceCompanies = [];
      if (board.referenceCompanies.some((item) => item && item.code === company.code)) return;
      board.referenceCompanies.push({ ...company });
    },
    /**
     * 문서 본문의 대상자(referenceUserId)를 결재선의 수신참조와 동기화한다.
     * - 대상자 선택: 참조로 추가 (이미 결재선에 있으면 그대로 둔다)
     * - 대상자 변경: 이전 대상자로 자동 추가했던 참조를 빼고 새 대상자를 넣는다
     * - 대상자 삭제: 자동 추가했던 참조만 뺀다 (작성자가 직접 넣은 다른 참조자는 유지)
     * 결재선을 고칠 수 있는 상태(신규/임시저장/내 결재 차례)에서만 동작한다.
     */
    async syncReferenceUser() {
      if (!this.approvalOptions.referenceUserPath) return;
      if (!this.canEditApprovalLine) return;

      const userId = this.referenceUserId;
      const line = Array.isArray(this.board.approvalLine) ? this.board.approvalLine.slice() : [];

      if (this.autoReferenceUserId && this.autoReferenceUserId !== userId) {
        const index = line.findIndex((member) => member && member.type_code === "reference" && parseInt(member.user_id) === this.autoReferenceUserId);
        if (index >= 0) line.splice(index, 1);
      }
      this.autoReferenceUserId = userId;

      // 이전 대상자 제거를 먼저 반영한 뒤 (회원 조회가 비동기라 그 사이 화면이 갱신되도록) 새 대상자를 조회한다
      this.board.approvalLine = line;
      if (!userId || line.some((member) => member && parseInt(member.user_id) === userId)) return;

      const entry = await this.buildReferenceEntry(userId);
      // 회원 조회 중 대상자가 또 바뀌었으면 이번 결과는 버린다 (다음 동기화가 처리)
      if (this.referenceUserId !== userId) return;
      if (this.board.approvalLine.some((member) => member && parseInt(member.user_id) === userId)) return;
      this.board.approvalLine = this.board.approvalLine.concat([entry]);
    },
    /**
     * 문서 본문의 대상자 객체(이름/부서명/파트명/직급/업체id/업체명)로 수신참조 결재선 항목을 만든다.
     * (회원 단건 조회 API(/member/{id})는 로그인 사용자 정보를 돌려주므로 쓰지 않는다)
     */
    async buildReferenceEntry(userId) {
      const keys = `${this.approvalOptions.referenceUserPath}`.split(".");
      let parent = this.form;
      for (const key of keys.slice(0, -1)) {
        parent = parent ? parent[key] : undefined;
      }
      const target = parent || {};
      return {
        company_id: parseInt(target.업체id) || 0,
        company_name: target.업체명 || "",
        department: target.파트명 || target.department || "",
        section: target.부서명 || target.section || "",
        user_id: userId,
        user_name: target.이름 || target.name || "",
        position: "",
        rank: target.직급 || target.rank || "",
        status_code: "wait",
        status_id: 1,
        status_name: "대기",
        type_id: 4,
        type_code: "reference",
        type_name: "참조",
      };
    },
    /**
     * approvalOptions.referenceUserPath 가 가리키는 문서 body 의 회원 id 를 수신참조로 추가한다.
     * (예: "대상자.id" → form.대상자.id, 이름은 같은 객체의 이름/name)
     * 상신 시 안전장치: 팝업에서 대상자 참조를 지웠더라도 승인 문서에는 항상 대상자가 참조로 들어가게 한다.
     * referenceUserWhen 조건에 맞지 않는 문서(예: 1229 사내·사외수급)는 넣지 않는다.
     */
    appendDefaultReferenceUser(line) {
      const path = this.approvalOptions.referenceUserPath;
      if (!path || !this.form) return;
      if (!this.isReferenceUserAllowed) return;
      const keys = `${path}`.split(".");
      let parent = this.form;
      for (const key of keys.slice(0, -1)) {
        parent = parent ? parent[key] : undefined;
      }
      const userId = parent ? parseInt(parent[keys[keys.length - 1]]) || 0 : 0;
      if (!userId) return;
      // 이미 결재선(결재/참조/회람 등)에 있으면 중복 추가하지 않는다
      if (line.some((item) => parseInt(item.id) === userId)) return;
      line.push({
        id: userId,
        name: (parent && (parent.이름 || parent.name)) || "",
        elementType: "reference",
      });
    },
    onClickOk() {
      this.$emit("approval", JSON.stringify(this.board.documentCompany), JSON.stringify(this.board.referenceCompanies));
    },
    onClickNo(text) {
      this.$emit("reject", text);
    },

    //
    // ===== button group =====
    //
    onClickDelete() {
      this.$emit("delete");
    },
    printLandscape() {
      this.print("@media print {@page { size: a3 landscape; }}");
    },
    printPortrait() {
      this.print("@media print {@page { size: a3 portrait; }}");
    },
    print(css) {
      // 프린트
      this.isPrint = true;

      if (this.tab) {
        document.getElementById("hidePrintTitle").value = this.tab.hidePrintTitle ? "true" : "false";
      }
      document.getElementById("isPrint").value = "true";
      setTimeout(() => {
        const printTextarea = document.getElementsByClassName("print-textarea");
        for (let i = 0; i < printTextarea.length; i++) {
          const pt_r = printTextarea[i].innerHTML.trimStart().trimEnd().replace(/\r\n/gi, "<br>").replace(/\\n/gi, "<br>").replace(/\n/gi, "<br>");

          document.getElementsByClassName("print-textarea")[i].innerHTML = pt_r;
        }

        const isPrint = document.getElementById("isPrint").value === "true";
        const hidePrintTitle = document.getElementById("hidePrintTitle").value === "true";

        const g_label = document.getElementById("print-label") ? document.getElementById("print-label").innerHTML : "";
        const g_oBeforeBody = document.getElementById("print-report").innerHTML;
        const g_oBeforeApproval = document.getElementById("print-approval").innerHTML;

        // 프린트를 보이는 그대로 나오기위한 셋팅
        window.onbeforeprint = function () {
          document.body.style.backgroundColor = "#fff";
          document.body.innerHTML = "";
          if (g_label && isPrint && !hidePrintTitle) {
            document.body.innerHTML += `${g_label}<br>`;
          }
          document.body.innerHTML += `${g_oBeforeBody}<br>${g_oBeforeApproval}`;
        };

        const head = document.head || document.getElementsByTagName("head")[0],
          style = document.createElement("style");

        style.type = "text/css";
        style.media = "print";

        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }

        head.appendChild(style);

        window.print();
        location.reload();
      }, 300);
    },
    onClickPrint() {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "레이아웃 선택",
          messageIcon: "AlertCircleIcon",
          message: "인쇄 방향을 선택해 주세요.",
          useConfirm: true,
          confirmBtn: "세로 방향",
          cancelBtn: "가로 방향",
          confirmFunction: () => this.printPortrait(),
          cancelFunction: () => this.printLandscape(),
          size: "small",
          btnPosition: "center",
          confirmBtnStyle: {
            type: "border",
            icon: { type: "image", name: "icon-print-layout-vertical.svg" },
            style: "",
          },
          cancelBtnStyle: {
            type: "border",
            icon: { type: "image", name: "icon-print-layout-horizontal.svg" },
            style: "",
          },
        },
      });
      window.dispatchEvent(customAlert);
    },
    onClickClose() {
      this.$emit("close");
    },
    onClickMoveList(pageType = "list") {
      this.$emit("move", pageType);
    },
    onClickRevision(message) {
      this.$emit("revision", JSON.stringify(this.lineToSendLine(this.board.approvalLine, true)), message);
    },
    onClickRecall() {
      this.$emit("recall", JSON.stringify(this.lineToSendLine(this.board.approvalLine)));
    },
    onClickTempsave() {
      if (this.isUpdateMode) {
        this.$emit("update", JSON.stringify(this.lineToSendLine(this.board.approvalLine)));
      } else {
        this.$emit("save", JSON.stringify(this.lineToSendLine(this.board.approvalLine)));
      }
    },
    onClickReTempsave(message) {
      this.$emit("retempsave", JSON.stringify(this.lineToSendLine(this.board.approvalLine)), message);
    },
    onClickCopySave(callback) {
      this.$emit("copysave", JSON.stringify(this.lineToSendLine(this.board.approvalLine)), callback);
    },

    //
    // ===== approval-process-module =====
    //
    _onClickApprovalUpload() {
      this.onClickUpload();
    },
    _onClickApprovalOk() {
      this.alert.html = "";
      this.alert.message = "승인하시겠습니까?";
      this.alert.isConfirm = false;
      this.alert.buttons = [
        { label: "승인", action: "ok" },
        { label: "취소", action: "cancel", type: "border" },
      ];
      this.alert.show = true;
    },
    _onClickApprovalNo() {
      this.alert.html = "<p>반려하시겠습니까?</p><p>아래에 사유를 작성해주세요.</p>";
      this.alert.message = "";
      this.alert.isConfirm = true;
      this.alert.buttons = [
        { label: "반려", action: "no" },
        { label: "취소", action: "cancel", type: "border" },
      ];
      this.alert.show = true;
    },
    _onChangeApproval(process, documentCompany, referenceDocumentCompanies) {
      this.board.approvalLine = process;
      this.board.documentCompany = documentCompany;
      this.board.referenceCompanies = referenceDocumentCompanies;
    },
  },
};
</script>

<style lang="scss" scoped>
.fix-grid {
  display: grid !important;
  grid-template-columns: minmax(70%, 9fr) 3fr;
}
.hide-grid {
  display: grid !important;
  grid-template-columns: minmax(100%, 9fr) 0px;
}
.toggle-btn {
  padding: 0.5rem !important;
  height: 100%;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  background-color: lightgray;
  color: #fff;
}
</style>
<style>
.con-vs-tabs .con-slot-tabs {
  overflow: initial;
}
</style>
